const massages = ["Klasická a relaxační masáž", "Rekondiční a sportovní masáž", "Masáž lávovými kameny", "Masáž Lomi- lomi", "Bresussova masáž", "Rašelinové obklady"]

export default massages